export default __webpack_public_path__ + "static/media/image.cubemak-labs.06e263f4.png";